import styled from "styled-components";

export const Container = styled.div`
  background-color: rgba(0, 0, 0, 0.45);
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 4;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .btn__modal {
    width: 100%;
    color: ${(props) => props.theme.colors.typography2.dark};
  }
`;

export const BlockWishList = styled.div`
  background-color: ${(props) => props.theme.colors.brand4.medium};
  padding: 24px;
  border-radius: 8px;
  width: 80%;

  @media (min-width: 480px) {
    width: 400px;
  }
  @media (min-width: 768px) {
    width: 280px;
  }
`;
export const ExiteButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 8px;

  .svg__exit--button {
    cursor: pointer;
    display: block;
    margin-left: auto;
  }
`;
